import '../../../themes/global.scss';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Screen } from '@tempmee/react';
import { BackButton } from '~/commonComponents';
import { fetchTodayJobs } from '../../../actions';
import { Table } from './Table';

export const TodayJobs = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTodayJobs({ page: 1 }));
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton />} title="Today's Professionals" />
      <Screen.Body>
        <Table />
      </Screen.Body>
    </Screen>
  );
};
